import theme from "../styles/Theme";

import { StyleProject, StyleProjectTitle, StyleContentsArea, StyleContentsLeft, StyleContentsRight, StyleContentsTitle, StyleContents, StyleContent, StyleProjectImage, StyleImages, StyleImage } from "../styles/StyleProjects"

import { StyleBadgeGreen } from '../styles/StyleCommon'

const BehindCoupon = () => {
    return (
        <div>
            <StyleProject>
                <StyleContentsArea theme={theme}>
                    <StyleContentsLeft>
                        <blockquote>
                            <StyleProjectTitle>2019.03 - 2019.05</StyleProjectTitle>
                            <StyleProjectTitle>비하인드 쿠폰</StyleProjectTitle>
                            <StyleBadgeGreen>spring batch</StyleBadgeGreen>
                            <StyleBadgeGreen>java 8</StyleBadgeGreen>
                            <StyleBadgeGreen>mysql 5.x</StyleBadgeGreen>
                            <StyleBadgeGreen>redis</StyleBadgeGreen>
                            <StyleBadgeGreen>hive</StyleBadgeGreen>
                            <StyleBadgeGreen>hadoop</StyleBadgeGreen>
                        </blockquote>
                    </StyleContentsLeft>
                    <StyleContentsRight>
                        <StyleContentsTitle>대량의 개인화 쿠폰 발급</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>개인화 비하인드(깜짝 쿠폰) 시스템 개발로 상품 구매 효율 증대에 기여</StyleContent>
                            <StyleContent>고객 마케팅 팀으로부터 적게는 몇만, 많게는 3000만건 이상의 개인화 쿠폰 발급 대상 정보를 hive 저장소로 인입</StyleContent>
                            <StyleContent>Hive에서 Redis를 거쳐 RDB로 이어지는 3단계 파이프라인으로 대규모 배치의 메모리 효율과 처리 안정성 확보</StyleContent>
                            <StyleContent>redis의 타겟 데이터를 기반으로 partition을 나누어 batch로 쿠폰 bulk 발급</StyleContent>
                        </StyleContents>
                    </StyleContentsRight>
                </StyleContentsArea>
            </StyleProject>
        </div>
    )
}

export default BehindCoupon
